import { IRepeatableElement } from "@graffer-inc/form-schema";
import { useMemo } from "react";

type TargetsCopyableEditorProps = {
  element: IRepeatableElement;
};

type CopyValue = {
  id: string;
  labelText: string;
  isCopyValue: boolean;
};

export const TargetsCopyableEditor: React.FC<TargetsCopyableEditorProps> = ({
  element,
}) => {
  const childElement = useMemo<CopyValue[]>(() => {
    const result = element.baseUnit.map((v) => ({
      id: v.id,
      labelText: v.label.text,
      isCopyValue: !!element.targetsCopyable?.includes(v.id),
    }));
    return result;
  }, [element]);

  const isTargetsCopyable = Array.isArray(element?.targetsCopyable);
  const copyableTargetsLabel = childElement
    .filter((v) => v.isCopyValue)
    .map((v) => v.labelText)
    .join(", ");

  return (
    <>
      <div className="field">
        <label className="label">入力内容をコピーした繰り返し</label>
      </div>
      {isTargetsCopyable ? (
        <>
          <div className="field">
            <p>コピーの対象とする項目</p>
          </div>
          <div className="field ml-4">
            <div className="control">
              <p>{copyableTargetsLabel}</p>
            </div>
          </div>
        </>
      ) : (
        <p>設定なし</p>
      )}
    </>
  );
};
